import { render, staticRenderFns } from "./GameView.vue?vue&type=template&id=e1634ca4&scoped=true&"
import script from "./GameView.vue?vue&type=script&lang=js&"
export * from "./GameView.vue?vue&type=script&lang=js&"
import style0 from "./GameView.vue?vue&type=style&index=0&id=e1634ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1634ca4",
  null
  
)

export default component.exports